"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfNotificationCountsDto = instanceOfNotificationCountsDto;
exports.NotificationCountsDtoFromJSON = NotificationCountsDtoFromJSON;
exports.NotificationCountsDtoFromJSONTyped = NotificationCountsDtoFromJSONTyped;
exports.NotificationCountsDtoToJSON = NotificationCountsDtoToJSON;
exports.NotificationCountsDtoToJSONTyped = NotificationCountsDtoToJSONTyped;
/**
 * Check if a given object implements the NotificationCountsDto interface.
 */
function instanceOfNotificationCountsDto(value) {
    if (!('all' in value) || value['all'] === undefined)
        return false;
    if (!('unread' in value) || value['unread'] === undefined)
        return false;
    return true;
}
function NotificationCountsDtoFromJSON(json) {
    return NotificationCountsDtoFromJSONTyped(json, false);
}
function NotificationCountsDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'all': json['all'],
        'unread': json['unread'],
    };
}
function NotificationCountsDtoToJSON(json) {
    return NotificationCountsDtoToJSONTyped(json, false);
}
function NotificationCountsDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'all': value['all'],
        'unread': value['unread'],
    };
}
